// the items of one list that the other doesn't have, counted per value: a dropped duplicate counts
export default function itemsNotIn(list, other) {
  var counts = new Map();
  for (var i = 0; i < other.length; i++) {
    var _counts$get;
    counts.set(other[i], ((_counts$get = counts.get(other[i])) != null ? _counts$get : 0) + 1);
  }
  var result = [];
  for (var _i = 0; _i < list.length; _i++) {
    var _counts$get2;
    var left = (_counts$get2 = counts.get(list[_i])) != null ? _counts$get2 : 0;
    if (left) counts.set(list[_i], left - 1);else result.push(list[_i]);
  }
  return result;
}